import React, { useState, useEffect } from 'react'
import Images from './images'
import { Typography, Col, Row, Radio, Form } from 'antd'
import Prenotazione from './prenotazione'

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px'
}

const ImagesBlock = (props) => {
  const [hasPics, setHasPics] = useState(true)
  // const [hasPics, setHasPics] = useState(props.isEditing || props.isBack)
  useEffect(() => {
    if (props.formValue.hasPic === '1') {
      setHasPics(true)
    }
  }, [props.formValue.hasPic])
  if (hasPics) {
    return (
      <>
        <Typography.Title>
          Inserisci le foto del tuo appartamento
        </Typography.Title>
        <p className='font-semibold text-gray-600 md:text-xl'>
          Aiutaci a far immaginare agli inquilini come sarà vivere nel tuo
          appartamento.
          <br />
          Un annuncio con le foto ti fa affittare casa 12 volte più velocemente
          che uno senza
        </p>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12} span={12}>
            <Images {...props} />
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} span={12}>
            <Prenotazione {...props} />
          </Col>
        </Row>
      </>
    )
  }
  return (
    <>
      <Col xs={24} sm={24} md={24} lg={12}>
        <Typography.Title>
          Hai già pronte le foto per l'annuncio?
        </Typography.Title>
        <Form.Item
          name='hasPic'
          rules={[
            {
              required: true
            }
          ]}
        >
          <Radio.Group className='text-xl'>
            <Radio style={radioStyle} value='0'>
              No
            </Radio>
            <Radio style={radioStyle} value='1'>
              Si
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
    </>
  )
}

export default ImagesBlock
